import styled from 'styled-components';
import { mq } from '../../../styles/mq';
import { theme } from '../../../styles/theme';

export const Title = styled.h3`
  text-align: center;
  margin-bottom: 1em;
  ${mq.medium} {
    margin-bottom: 0;
  }
`;

export const Grid = styled.div`
  display: block;
  ${mq.medium} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 2rem;
  }
  ${mq.xlarge} {
    row-gap: 2rem;
  }
`;
export const Woman = styled.div`
  display: block;
  ${mq.medium} {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
  }
  &:nth-child(2) {
    flex-direction: row;
    ${mq.large} {
      margin-right: 6rem;
    }
    > div:last-child {
      ${mq.large} {
        transform: translateY(-20%);
      }
    }
  }
  &:nth-child(3) {
    ${mq.large} {
      margin-left: 6rem;
    }
  }
  &:nth-child(4) {
    flex-direction: row;
    > div:last-child {
      ${mq.large} {
        transform: translateY(-25%);
      }
    }
  }
  > div {
    width: 100%;
    ${mq.medium} {
      width: 52%;
    }
  }
  .img-container {
    ${mq.smallOnly} {
      width: 80%;
    }
    width: 60%;
    margin: auto;
    ${mq.medium} {
      width: 48%;
    }
    /* width: 342px;*/
  }
  img {
    width: 100%;
  }
  &:nth-child(1) {
    top: -4rem;
    div:nth-child(2) {
      ${mq.large} {
        margin-right: 4rem;
      }
    }
    div img {
      transform: scaleX(-100%);
    }
  }
  &:nth-child(3) {
    div img {
      transform: scaleX(-100%);
    }
  }
  &:nth-child(4) {
    div:nth-child(1) {
      ${mq.large} {
        margin-left: 2rem;
      }
    }
  }
`;
export const Bubble = styled.div<{ $dir: string }>`
position: relative;
  border-radius: 3rem;
  border: 1px solid ${theme.colors.text};
  padding: 2rem 2.4rem;
  font-family: "skolar-latin", serif;
  ${mq.smallOnly} {
    font-size: 1.6rem;
  }
  border-radius: 2rem;
  ${mq.medium} {
    font-size: 1.6rem;
    line-height: 1.3;
  }
  ${mq.large} {
    padding: 2.4rem 3.2rem;
    font-size: 1.9rem;
  }
  ${mq.xlarge} {
    font-size: 2.1rem;
  }
    font-style: italic;
  svg.horizontal {
    
    position: absolute;
    ${(props) =>
      props.$dir === 'right'
        ? 'left:100%; transform:translate(-0.5px,-50%);'
        : 'right: 100%; transform:translate(0.5px,-50%);'}
    top: 50%;
    display: none;
    ${mq.medium} {
    display: block;
      width: 26px;
    }
    ${mq.large} {
      width: 32px;
    }
    ${mq.xlarge} {
      width: 36px;
    }
     
  }
    svg.vertical {
    position: absolute;
    top: 100%;
    left: 85%;
    width: 20px;
    ${mq.medium} {
    width: 32px;
      display: none;
    }
`;
